import React from 'react';
import intl from 'react-intl-universal';
import { getParameterByName } from '../../querystring.js';

const locales = {
    'pt-BR': require('../../locales/pt-BR.json'),
    'en-US': require('../../locales/en-US.json'),
    'es-ES': require('../../locales/es-ES.json')
};

export function Modal() {

    const querystring = getParameterByName('lang');

    const language = querystring ? querystring : navigator.language;

    const currentLocale = locales[language] ? language : 'pt-BR';

    intl.init({
        currentLocale,
        locales
    });

    function handleSubmit(e) {
        e.preventDefault();
        // console.log('Você clicou em enviar.');

        const click = document.getElementById('result-nps');
        const hideT = document.getElementById('clic');
        click.style.display = 'flex';
        hideT.style.display = 'none';
      }
    


    return (
        <>
            <div className="show_error">
                    <div style={{ textAlign: 'center', paddingTop: '55px' }}>
                        <button id="clic" onClick={handleSubmit}
                            style={{ border: 'none', padding: '15px 42px', background: '#ff870c', color: '#fff', borderRadius: '50px', textDecoration: 'none', fontSize: '20px', }}>
                            {intl.get('buttons.resultado')}
                        </button>
                </div>
            </div>
        </>
    );
}